import { render, staticRenderFns } from "./AcademicInfoSection.vue?vue&type=template&id=028bbe7e&scoped=true"
import script from "./AcademicInfoSection.vue?vue&type=script&lang=js"
export * from "./AcademicInfoSection.vue?vue&type=script&lang=js"
import style0 from "./AcademicInfoSection.vue?vue&type=style&index=0&id=028bbe7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028bbe7e",
  null
  
)

export default component.exports